import React from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(6),
    },
    icon: {
      fontSize: 64,
      color: theme.palette.success.main,
      marginBottom: theme.spacing(2),
    },
    link: {
      marginTop: theme.spacing(2),
      fontWeight: 500,
    },
  })
);

interface CompleteViewProps {
  title?: string;
  subtitle?: string;
  summary?: string;
  helpText?: string;
  linkText?: string;
  linkHref?: string;
}

export function CompleteView({
  title = 'Complete!',
  subtitle,
  summary,
  helpText,
  linkText,
  linkHref,
}: CompleteViewProps) {
  const classes = useStyles();
  const displayText = summary || subtitle || '';

  return (
    <Box className={classes.container}>
      <CheckCircle className={classes.icon} />
      <Typography variant='h6' gutterBottom>
        {title}
      </Typography>
      {displayText && (
        <Typography variant='body2' color='textSecondary' style={{ textAlign: 'center', maxWidth: 400 }}>
          {displayText}
        </Typography>
      )}
      {helpText && (
        <Typography variant='body2' color='textSecondary' style={{ marginTop: 16 }}>
          {helpText}
        </Typography>
      )}
      {linkText && linkHref && (
        <Link href={linkHref} className={classes.link} color='primary'>
          {linkText}
        </Link>
      )}
    </Box>
  );
}
